module.exports = {"330681001":"暨阳街道","330681002":"浣东街道","330681003":"陶朱街道","330681004":"暨南街道","330681005":"大唐街道","330681102":"应店街镇","330681103":"次坞镇","330681104":"店口镇","330681106":"姚江镇","330681108":"山下湖镇","330681109":"枫桥镇","330681110":"赵家镇","330681111":"马剑镇","330681112":"五泄镇","330681115":"牌头镇","330681116":"同山镇","330681117":"安华镇","330681119":"璜山镇","330681120":"陈宅镇","330681121":"岭北镇","330681122":"浬浦镇","330681124":"东白湖镇","330681201":"东和乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330681.json
// module id = 1098
// module chunks = 0